import * as React from 'react';

import {ContentModal} from '../ui/modals/ContentModal/ContentModal';
import {Exceptions} from '../exceptions/exceptions.class';
import {User} from '../users/user.class';
import Button from '../ui/Buttons/Button';

interface ExceptionIconsProps {
    exceptions: Exceptions;
    excludeStSeeMore: any;
    onHide: () => void;
    onSeeAll: () => void;
    shortlist: any;
    show: boolean;
    user: User;
}

export const ExceptionsModal = ({exceptions, excludeStSeeMore, onHide, onSeeAll, shortlist, show, user}: ExceptionIconsProps) => (
    <ContentModal
        onClose={onHide}
        show={show}
        title="Compliance and Restrictions"
    >
        <>
            {user?.hasCustomCatalogs() && exceptions.itemNeedsAppr && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="Custom Catalog Icon"
                            src="/btns/custom-catalog-icon.gif"
                            style={{maxWidth: 30}}
                            title="Approved for your custom catalog"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">Approved for your custom catalog.</div>
                </div>
            )}
            {(exceptions.prop65b_b === true || exceptions.prop65c_b === true || exceptions.prop65Message) && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="California Proposition 65 Icon"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/warning.png"
                            style={{maxWidth: 30}}
                            title={exceptions.prop65Message}
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">WARNING: {exceptions.prop65Message}</div>
                </div>
            )}
            {exceptions.canShipAir === false && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="Product cannot be shipped AIR freight"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/AirshipExclusion.png"
                            style={{maxWidth: 30}}
                            title="Product cannot be shipped AIR freight"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">
                        This product is prohibited from Air Shipment
                    </div>
                </div>
            )}
            {exceptions.excludeStArray && exceptions.excludeStArray.length > 0 && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="State ship exclusion"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/StateShipExclusion.png"
                            style={{maxWidth: 30}}
                            title="State ship exclusion"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">
                        <span className="tw-mr-2">Product cannot ship to States or Zip Codes:</span>
                        {shortlist}
                        {excludeStSeeMore && (
                            <Button
                                className="tw-text-blue-200 tw-ml-2 tw-mb-[2px]"
                                onClick={() => {
                                    onHide();
                                    onSeeAll();
                                }}
                                size="sm"
                                variant="link"
                            >
                                See All
                            </Button>
                        )}
                    </div>
                </div>
            )}
            {exceptions.upsHazard && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="Hazardous Freight Charge"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/HazardousFreightCharge.png"
                            style={{maxWidth: 30}}
                            title="Hazardous Freight Charge"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">Hazardous Material</div>
                </div>
            )}
            {exceptions.ormd && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="ORM-D Product"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/ORM_D.png"
                            style={{maxWidth: 30}}
                            title="ORM-D Product"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">Limited Quantities Product</div>
                </div>
            )}
            {(exceptions.lotTrack || exceptions.lottracking) && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="Lot Tracked Item"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/LotTrackedItem.png"
                            style={{maxWidth: 30}}
                            title="Lot Tracked Item"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">Lot Tracked Item</div>
                </div>
            )}
            {(exceptions.sdsLink || exceptions.msdsavail || exceptions.graMsdsavail_b) && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="SDS Available"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/SDSSheet.png"
                            style={{maxWidth: 30}}
                            title="SDS Available"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">
                        <span className="tw-mr-2">SDS Available</span>
                        {exceptions.sdsAssetFileName_s ? (
                            <>
                                <a
                                    href={`/SDS/${exceptions.id}`}
                                    target="_blank"
                                >
                                    View
                                </a>{' '}
                                |{' '}
                                <a
                                    href={`/SDS/download/${exceptions.id}/${encodeURIComponent(exceptions.sdsAssetFileName_s)}`}
                                    target="_blank"
                                >
                                    Download
                                </a>
                            </>
                        ) : exceptions.graMsdsavail_b && exceptions.GSDP_ID_s ? (
                            <a
                                href={`/SDS/GDSP/${exceptions.GSDP_ID_s}`}
                                rel="nofollow"
                                target="_blank"
                            >
                                View
                            </a>
                        ) : (
                            exceptions.sds_s && (
                                <a
                                    href={`/SDS/${exceptions.sds_s}`}
                                    target="_blank"
                                >
                                    SDS Available
                                </a>
                            )
                        )}
                    </div>
                </div>
            )}
            {exceptions.bin && (
                <div className="tw-grid tw-grid-cols-12 tw-mb-4">
                    <div className="tw-col-span-2 md:tw-col-span-1 tw-w-full tw-relative tw-text-center">
                        <img
                            alt="Labeled in shop"
                            className="tw-max-w-full tw-h-auto"
                            src="/btns/ItemLabeledInShop.png"
                            style={{maxWidth: 30}}
                            title="Labeled in shop"
                        />
                    </div>
                    <div className="tw-col-span-10 md:tw-col-span-11 tw-w-full tw-relative">Labeled in shop</div>
                </div>
            )}
        </>
    </ContentModal>
);
